import { formatDateTime, TimeFormatType } from '../../../utils/date';

export const EXPORT_USER_FILE_NAME = `entrada_users_${formatDateTime(new Date(), TimeFormatType.FILENAME)}`;

export type UserInfoItem = {
  label: string;
  value: string;
};
